import { FilterAlt } from '@styled-icons/boxicons-solid'
import InputText from '../../common/InputText'
import SelectInput from '../../common/SelectInput'
import Button from '../../common/Button'
import { useEffect, useState } from 'react'
import { getRequest } from '../../../services/base'
import { useParams } from 'react-router-dom'
import { toTitleCase } from '../../../utils/common'

const ConnectorSearchFilter = (props) => {
  const { vehicle } = useParams()
  const [categoryOptions, setCategoryOptions] = useState([])
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [connectorName, setConnectorName] = useState('')
  const [showConnectorFilter, setShowConnectorFilter] = useState(false)

  useEffect(() => {
    getConnectorCategory()
  }, [])

  const getConnectorCategory = async () => {
    let res = await getRequest(`/api/connector/category/?vehicle=${vehicle}`)
    setCategoryOptions(res.data)
  }

  return (
    <div>
      <FilterAlt
        size={'2rem'}
        className="p-1 cursor-pointer"
        onClick={() => {
          setShowConnectorFilter(!showConnectorFilter)
        }}
      />
      {showConnectorFilter && (
        <div style={{ position: 'relative', left: '100%' }}>
          <div
            className={'menu-option-wrapper bg-tracer-darker-blue w-full ml-1'}
            style={{
              position: 'absolute',
              zIndex: 100,
              width: '20vw',
            }}
          >
            <div className="p-1 bg-tracer-lt-blue rounded-t ">
              <span
                className={`text-2xl float-right cursor-pointer pr-2`}
                onClick={() => {
                  setShowConnectorFilter(false)
                }}
              >
                &times;
              </span>
              <InputText
                name="search_connector"
                onChange={(e) => {
                  setConnectorName(e)
                }}
                label={'Name'}
                isRequired={false}
                value={connectorName}
                type={'search'}
              />
              <SelectInput
                name="category"
                label="Category"
                isRequired={false}
                options={categoryOptions.map((val) => ({
                  value: val,
                  label: toTitleCase(val),
                }))}
                onChange={(value) => {
                  setSelectedCategory(value)
                }}
                value={selectedCategory}
              />

              <div className="flex justify-end p-2">
                <Button
                  className={`cursor-pointer btn my-2 bg-tracer-chrome-blue`}
                  text={`Search`}
                  onClick={() => {
                    props.filterConnector(
                      connectorName,
                      selectedCategory?.value
                    )
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ConnectorSearchFilter
